module.exports = __webpack_public_path__ + "media/images/application/template/download-0dde7d2007610692c17b95ff3f10d2b8.svg";